import OSTransactionsScreen from './OSTransactionsScreen';
export default OSTransactionsScreen;
